<template>
    <div class="cashup-form">
        <el-row :gutter="10" class="cashup__row">
            <el-col class="cashup__row--col" :xs="24" :sm="24" :md="12" :lg="13" :xl="13">
                <table class="cashup__table">
                    <tbody>
                        <tr>
                            <td class="w-90 p-10">DATE:</td>
                            <td colspan="2">
                                <el-input v-model="form.date"  type="text" :disabled="true" class="peiso-input-default"></el-input>
                            </td>
                            <td class="w-90 p-10">CASHIER:</td>
                            <td colspan="3">
                                <el-input v-model="form.cashier"   type="text" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="w-90 p-10 uppecase">{{type}}</td>
                            <td class="h-35" colspan="2"></td>
                            <td class="w-90 p-10"></td>
                            <td class="h-35" colspan="3"></td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center uppecase" colspan="6">
                                {{type}}
                            </td>
                        </tr>
                        <tr>
                            <td class="d-flex justify-content-center">
                                <div @click="addItem(form.tyros, [
                                    {
                                        name: 'Eftpos',
                                        tyro: '',
                                        surcharge: '',
                                        refund: '',
                                    },
                                    {
                                        name: 'Visa',
                                        tyro: '',
                                        surcharge: '',
                                        refund: '',
                                    },
                                    {
                                        name: 'Mastercard',
                                        tyro: '',
                                        surcharge: '',
                                        refund: '',
                                    },
                                    {
                                        name: 'Unionpay',
                                        tyro: '',
                                        surcharge: '',
                                        refund: '',
                                    },
                                    {
                                        name: 'Amex',
                                        tyro: '',
                                        surcharge: '',
                                        refund: '',
                                    },
                                    {
                                        name: '',
                                        tyro: '',
                                        surcharge: '',
                                        refund: '',
                                    },

                                ])"
                             class="">
                                    <el-button width="50" height="50" type="peiso-success">+</el-button>
                                </div>
                            </td>
                            <td colspan="1" class="h-35"></td>
                            <td class="h-35" colspan="2"></td>
                            <td class="h-35 text-center">Tyro</td>
                            <td class="h-35 text-center">Surcharge</td>
                            <td class="h-35 text-center">REFUND</td>
                        </tr>
                        <!-- Tyro list -->
                        <template v-for="(tyro, i) in form.tyros">
                            <tr v-for="(item, index) in tyro">
                                <td width="60" v-if="index == 0" :rowspan="tyro.length" class="p-10 text-center">
                                    <div @click="removeItem(i, 'tyros')" class="d-flex justify-content-center align-items-center">
                                        <el-button width="50" height="50" type="peiso-danger">-</el-button>
                                    </div>
                                </td>
                                <td colspan="1" v-if="index == 0" :rowspan="tyro.length" class="p-10 text-center">Tyro {{i + 1}}</td>

                                <td colspan="2" class="h-35 text-center">{{item.name}}</td>
                                <td class="h-35 text-center w-102">
                                    <el-input v-model="item.tyro"    type="number" class="peiso-input-default"></el-input>
                                </td>
                                <td class="h-35 text-center w-102">
                                    <el-input v-model="item.surcharge"   type="number" class="peiso-input-default"></el-input>
                                </td>
                                <td class="h-35 text-center w-102">
                                    <el-input v-model="item.refund"   type="number" class="peiso-input-default"></el-input>
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td colspan="3" class="h-35 text-center">Total</td>
                            <td class="h-35"></td>
                            <td class="h-35 text-center w-102">
                                <el-input v-model="form.totalTyro" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-102">
                                <el-input v-model="form.totalSurcharge" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-102">
                                <el-input v-model="form.totalRefund" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6" class="h-35 text-center"></td>
                        </tr>
                        <!-- Function list -->
                        <tr>
                            <td colspan="1" class="h-35 text-center"></td>
                            <td colspan="3" class="h-35 text-center">FUNCTIONS</td>
                            <td class="h-35 text-center">TYPE</td>
                            <td class="h-35 text-center">Covers</td>
                            <td class="h-35 text-center">TOTAL</td>
                        </tr>

                        <tr v-for="(item, i) in form.functions" :key="i">
                            <td colspan="1" class="h-35 text-center">
                                <template v-if="(form.functions.length - 1) == i">
                                    <div @click="addItem(form.functions, {
                                        name: '',
                                        type: 'FUNCTION',
                                        covers: '',
                                        total: ''})"
                                 class="d-flex justify-content-center align-items-center">
                                        <el-button width="50" height="50" type="peiso-success">+</el-button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div @click="removeItem(i, 'functions')" class="d-flex justify-content-center align-items-center">
                                        <el-button width="50" height="50" type="peiso-danger">-</el-button>
                                    </div>
                                </template>


                            </td>
                            <td colspan="3" class="h-35 text-center">
                                <el-input v-model="item.name"   type="text" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center">{{item.type}}</td>
                            <td class="h-35 text-center w-102">
                                <el-input v-model="item.covers"   type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-102">
                                <el-input v-model="item.total"   type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4" class="h-35 text-center">TOTAL</td>
                            <td class="h-35 text-center"></td>
                            <td class="h-35 text-center w-102">
                                <el-input v-model="form.totalCovers" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-102">
                                <el-input v-model="form.totalFunction" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="6" class="h-35 text-center">
                                BAR REVENUE
                            </td>
                            <td class="h-35 text-center w-102">
                                <el-input v-model="form.barRevenue"   type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>


                    </tbody>
                </table>
            </el-col>
            <el-col class="cashup__row--col" :xs="24" :sm="24" :md="12" :lg="11" :xl="11">
                <table class="cashup__table">
                    <tbody>

                        <tr>
                            <td colspan="4" class="h-35 text-center uppecase">{{type}}</td>
                        </tr>

                        <tr>
                            <td class="h-35 text-center"></td>
                            <td class="h-35 text-center">Tyro Total</td>
                            <td class="h-35 text-center">BEPOZ</td>
                            <td class="h-35 text-center">Variance</td>
                        </tr>

                        <tr v-for="(lunch, i) in form.lunchTotals">
                            <td class="h-35 text-center">{{lunch.name}}</td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="lunch.total"  :disabled="true" type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="lunch.bepoz" @change="onChangeLunchTotals"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="lunch.variance" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>

                        <tr>
                            <td class="h-35 text-center uppercase">TOTAL {{type}}</td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="form.totalLunchTyro"  :disabled="true" type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="form.totalLunchBepoz" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="form.totalLunchVariance" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="4" class="h-35 text-center"></td>
                        </tr>

                        <tr>
                            <td colspan="2" class="h-35 text-center">Denomination</td>
                            <td class="h-35 text-center">Count</td>
                            <td class="h-35 text-center">Total</td>
                        </tr>
                        <tr v-for="(denomination, i) in form.denominations">
                            <td colspan="2" class="h-35 text-center">{{$box.formatMoney5(denomination.amount)}}</td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="denomination.count"   type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="denomination.total" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" class="h-35 text-center"></td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="form.denominationTotal" @change="onChangeTotalDenomination" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center w-130">
                                Opening Float:
                            </td>
                            <td class="h-35 text-center">
                                <el-input @change="onChangeOpeningFloat" v-model="form.openingFloat"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-130">
                                Closing Float:
                            </td>
                            <td class="h-35 text-center">
                                <el-input @change="onChangeClosingFloat" v-model="form.closingFloat"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr v-for="(payment, i) in form.paymentList">
                            <td colspan="2" class="h-35">
                                {{ payment.name }}
                            </td>
                            <td colspan="2" class="h-35">
                                <el-input v-model="payment.amount" :disabled="payment.disabled"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35" colspan="4">OTHER PAYMENT TYPES / ACCOUNTS</td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center"></td>
                            <td class="h-35 text-center">AMOUNT</td>
                            <td class="h-35 text-center" colspan="2">Notes</td>
                        </tr>
                        <tr v-for="(other, i) in form.otherPaymentAccounts">
                            <td class="h-35 text-center">{{other.name}}</td>
                            <td class="h-35">
                                <el-input v-model="other.amount"   type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35" colspan="2">
                                <el-input v-model="other.notes"   type="text" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center">TOTAL OTHERS</td>
                            <td class="h-35">
                                <el-input v-model="form.totalOthers" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35" colspan="2"></td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center" colspan="4">
                                SUMMARY
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center">
                                TOTAL TAKINGS
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.totalTakings" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center">
                                FOOD
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.food"   type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center">
                                Less CC Tips / Grat
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.lessCcTipsGrat" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center">
                                BEV
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.bev"   type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center">
                                Less CC Surcharge
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.lessCcSurcharge" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center">
                                OTHER
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.other"   type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center">
                                Add Open Table
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.addOpenTable"   type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center">
                                TOTAL SALES
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.totalSales" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center">
                                TOTAL
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.total" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center">

                            </td>
                            <td class="h-35 w-101">

                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center">
                                TOTAL LESS GST
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.totalLessGst" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center">
                                TOTAL LESS GST
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.totalLessGst2" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="h-35 text-center">

                            </td>
                            <td class="h-35 w-101">

                            </td>
                            <td class="h-35 text-center">
                                Check
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.check" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="h-35 text-center">
                               TOTAL COVERS
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.totalCovers"   type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="h-35 text-center">
                               BAR COVERS
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.barCover"   type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="h-35 text-center">
                               SPH
                            </td>
                            <td class="h-35 w-101">
                                <el-input v-model="form.summary.sph" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                            <td></td>
                        </tr>

                    </tbody>
                </table>
            </el-col>
         </el-row>

         <table class="cashup__table">
            <tbody>
                <tr>
                    <td colspan="7" class="h-35">
                        COMPS / CONTRA
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td class="h-35 text-center w-101">Name</td>
                    <td class="h-35 text-center w-101">Pax</td>
                    <td class="h-35 text-center w-101">Amount</td>
                    <td colspan="4" class="h-35 text-center">Reason</td>
                </tr>
                <tr v-for="(item, i) in form.compsContra">
                    <td>
                        <template v-if="(form.compsContra.length - 1) == i">
                            <div @click="addItem(form.compsContra, {
                                name: '',
                                pax: '',
                                amount: '',
                                reason: ''})"
                         class="d-flex justify-content-center align-items-center">
                                <el-button width="50" height="50" type="peiso-success">+</el-button>
                            </div>
                        </template>
                        <template v-else>
                            <div @click="removeItem(i, 'compsContra')" class="d-flex justify-content-center align-items-center">
                                <el-button width="50" height="50" type="peiso-danger">-</el-button>
                            </div>
                        </template>
                    </td>
                    <td class="h-35 w-101">
                        <el-input v-model="item.name"   type="text" class="peiso-input-default"></el-input>
                    </td>
                    <td class="h-35 w-101">
                        <el-input v-model="item.pax"   type="number" class="peiso-input-default"></el-input>
                    </td>
                    <td class="h-35 w-101">
                        <el-input v-model="item.amount"   type="number" class="peiso-input-default"></el-input>
                    </td>
                    <td class="h-35">
                        <el-input v-model="item.reason"   type="text" class="peiso-input-default"></el-input>
                    </td>
                </tr>
            </tbody>
         </table>

         <table class="cashup__table">
            <tbody>
                <tr>
                    <td colspan="7" class="h-35">
                        DISCOUNTS
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td class="h-35 text-center w-101">Name</td>
                    <td class="h-35 text-center w-101">Pax</td>
                    <td class="h-35 text-center w-101">Amount</td>
                    <td colspan="4" class="h-35 text-center">Reason</td>
                </tr>
                <tr v-for="(item, i) in form.discounts">
                    <td>
                        <template v-if="(form.discounts.length - 1) == i">
                            <div @click="addItem(form.discounts, {
                                name: '',
                                pax: '',
                                amount: '',
                                reason: ''})"
                         class="d-flex justify-content-center align-items-center">
                                <el-button width="50" height="50" type="peiso-success">+</el-button>
                            </div>
                        </template>
                        <template v-else>
                            <div @click="removeItem(i, 'discounts')" class="d-flex justify-content-center align-items-center">
                                <el-button width="50" height="50" type="peiso-danger">-</el-button>
                            </div>
                        </template>
                    </td>
                    <td class="h-35 w-101">
                        <el-input v-model="item.name"   type="text" class="peiso-input-default"></el-input>
                    </td>
                    <td class="h-35 w-101">
                        <el-input v-model="item.pax"   type="number" class="peiso-input-default"></el-input>
                    </td>
                    <td class="h-35 w-101">
                        <el-input v-model="item.amount"   type="number" class="peiso-input-default"></el-input>
                    </td>
                    <td class="h-35">
                        <el-input v-model="item.reason"   type="text" class="peiso-input-default"></el-input>
                    </td>
                </tr>
            </tbody>
         </table>

         <el-row :gutter="10" class="cashup__row">
            <el-col class="cashup__row--col" :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
                <table class="cashup__table">
                    <tbody>
                        <tr>
                            <td colspan="4" class="h-35 text-center">PETTY CASH</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td colspan="2" class="h-35 text-center">Item</td>
                            <td class="h-35 text-center w-101">Amount</td>
                        </tr>
                        <tr v-for="(cash, i) in form.pettyCashList">
                            <td>
                                <template v-if="(form.pettyCashList.length - 1) == i">
                                    <div @click="addItem(form.pettyCashList, {
                                        item: '',
                                        amount: ''})"
                                 class="d-flex justify-content-center align-items-center">
                                        <el-button width="50" height="50" type="peiso-success">+</el-button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div @click="removeItem(i, 'pettyCashList')" class="d-flex justify-content-center align-items-center">
                                        <el-button width="50" height="50" type="peiso-danger">-</el-button>
                                    </div>
                                </template>
                            </td>
                            <td colspan="2" class="h-35 text-center">
                                <el-input v-model="cash.item"   type="text" class="peiso-input-default"></el-input>
                            </td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="cash.amount" @change="onChangePettyCash"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" class="h-35 text-center">Total</td>
                            <td class="h-35 text-center w-101">
                                <el-input v-model="form.pettyCashTotal" :disabled="true"  type="number" class="peiso-input-default"></el-input>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </el-col>
        </el-row>
    </div>
</template>

<style lang="scss">

    .cashup-form {
        .uppercase {
            text-transform: uppercase !important;
        }
        .capitalize {
            text-transform: capitalize !important;
        }

        .el-input.is-disabled .el-input__inner {
            background-color: var(--background-color-2) !important;
            border-color: var(--background-color-2) !important;
        }


        .el-button {
            padding: revert-layer !important;
        }
    }

</style>
<script>
import utils from '@/utils/utils';
import cashup from '@/api/cashup'

const form = {
    type: '',
    venueType: '',
    date: '',
    cashier: '',
    totalSurcharge: 0,
    totalRefund: 0,
    totalTyro: 0,
    totalCovers: 0,
    totalFunction: 0,
    barRevenue: '',
    totalLunchTyro: 0,
    totalLunchBepoz: 0,
    totalLunchVariance: 0,
    denominationTotal: 0,
    openingFloat: 0,
    closingFloat: 0,
    totalOthers: 0,
    pettyCashTotal: 0,
    pettyCashList: [
        {
            item: '',
            amount: ''
        }
    ],
    compsContra: [
        {
            name: '',
            pax: '',
            amount: '',
            reason: ''
        },
    ],
    discounts: [
        {
            name: '',
            pax: '',
            amount: '',
            reason: ''
        },

    ],
    tyros: [
        [
            {
                name: 'Eftpos',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Visa',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Mastercard',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Unionpay',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Amex',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: '',
                tyro: '',
                surcharge: '',
                refund: '',
            },

        ],
        [
            {
                name: 'Eftpos',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Visa',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Mastercard',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Unionpay',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Amex',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: '',
                tyro: '',
                surcharge: '',
                refund: '',
            },

        ],
        [
            {
                name: 'Eftpos',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Visa',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Mastercard',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Unionpay',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Amex',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: '',
                tyro: '',
                surcharge: '',
                refund: '',
            },

        ],
        [
            {
                name: 'Eftpos',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Visa',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Mastercard',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Unionpay',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Amex',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: '',
                tyro: '',
                surcharge: '',
                refund: '',
            },

        ],
        [
            {
                name: 'Eftpos',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Visa',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Mastercard',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Unionpay',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Amex',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: '',
                tyro: '',
                surcharge: '',
                refund: '',
            },

        ],
        [
            {
                name: 'Eftpos',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Visa',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Mastercard',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Unionpay',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: 'Amex',
                tyro: '',
                surcharge: '',
                refund: '',
            },
            {
                name: '',
                tyro: '',
                surcharge: '',
                refund: '',
            },

        ],
    ],
    lunchTotals: [
        {
            name: 'Eftpos',
            total: 0,
            bepoz: 0,
            variance: 0
        },
        {
            name: 'Visa',
            total: 0,
            bepoz: 0,
            variance: 0
        },
        {
            name: 'Mastercard',
            total: 0,
            bepoz: 0,
            variance: 0
        },
        {
            name: 'Amex',
            total: 0,
            bepoz: 0,
            variance: 0
        },
        {
            name: 'Unionpay',
            total: 0,
            bepoz: 0,
            variance: 0
        },
        {
            name: '',
            total: 0,
            bepoz: 0,
            variance: 0
        },
    ],
    functions: [
        {
            name: '',
            type: 'FUNCTION',
            covers: '',
            total: ''
        }

    ],
    otherPaymentAccounts: [
        {
            name: 'Deposit',
            amount: '',
            notes: ''
        },
        {
            name: '',
            amount: '',
            notes: ''
        },
        {
            name: '',
            amount: '',
            notes: ''
        },
        {
            name: '',
            amount: '',
            notes: ''
        },
        {
            name: '',
            amount: '',
            notes: ''
        },
        {
            name: 'SOH',
            amount: '',
            notes: ''
        },
        {
            name: 'Gift Voucher',
            amount: '',
            notes: ''
        },
        {
            name: '',
            amount: '',
            notes: ''
        },
        {
            name: 'Sundry',
            amount: '',
            notes: ''
        },
        {
            name: 'Accounts',
            amount: '',
            notes: ''
        },
        {
            name: '',
            amount: '',
            notes: ''
        },

    ],
    paymentList: [
        {
            name: 'CASH TAKINGS (BEPOZ)',
            amount: 0,
            disabled: false,
        },
        {
            name: 'LESS CC TIPS',
            amount: 0,
            disabled: false,
        },
        {
            name: 'LESS GRATUITY',
            amount: 0,
            disabled: false,
        },
        {
            name: 'LESS PETTY CASH',
            amount: 0,
            disabled: true,
        },
        {
            name: 'TOTAL BANKING (DRAWER)',
            amount: 0,
            disabled: true,
        },
        {
            name: 'Up/Down',
            amount: 0,
            disabled: true,
        },
    ],
    denominations: [
        {
            amount: 100,
            count: 0,
            total: 0
        },
        {
            amount: 50,
            count: 0,
            total: 0
        },
        {
            amount: 20,
            count: 0,
            total: 0
        },
        {
            amount: 10,
            count: 0,
            total: 0
        },
        {
            amount: 5,
            count: 0,
            total: 0
        },
        {
            amount: 2,
            count: 0,
            total: 0
        },
        {
            amount: 1,
            count: 0,
            total: 0
        },
        {
            amount: 0.50,
            count: 0,
            total: 0
        },
        {
            amount: 0.20,
            count: 0,
            total: 0
        },
        {
            amount: 0.10,
            count: 0,
            total: 0
        },
        {
            amount: 0.05,
            count: 0,
            total: 0
        },
    ],

    summary: {
        totalTakings: 0,
        lessCcTipsGrat: 0,
        lessCcSurcharge: 0,
        addOpenTable: 0,
        total: 0,
        totalLessGst: 0,
        food: 0,
        bev: 0,
        other: 0,
        totalSales: 0,
        totalLessGst2: 0,
        check: 0,
        totalCovers: 0,
        barCover: 0,
        sph: 0
    }
}
export default {
    props: ['type', 'activeType', 'venueType', 'reportDate', 'isOpen'],
    data() {
        return {
            newFunction: {
                name: '',
                type: 'FUNCTION',
                covers: '',
                total: ''
            },
            form: form,
        }
    },
    watch: {
        isOpen() {
            this.getCashup();
        },
        reportDate() {
            this.form.date = this.convertDate(this.reportDate);
            console.log('reportDate test: ', this.reportDate);
        },
        type() {
            this.getCashup();
            // const form = localStorage.getItem(`${this.type}-data`);
            // if (form && this.activeType == this.type) {
            //     console.log(`${this.type}-data`, this.activeType, JSON.parse(form));
            //     this.form = JSON.parse(form);
            // }
        },
        'form': {
            handler() {

                // clearTimeout(this._timeout);
                // this._timeout = setTimeout(() => {
                //     this.saveCashup(false);

                // }, 4000);


            },
            deep: true
        },
        'form.summary': {
            handler() {
                this.form.summary.total = (this.parseNumber(this.form.summary.totalTakings) + this.parseNumber(this.form.summary.lessCcTipsGrat) + this.parseNumber(this.form.summary.lessCcSurcharge)).toFixed(2);
                // this.form.summary.addOpenTable = (this.parseNumber(this.form.summary.totalTakings) + this.parseNumber(this.form.summary.lessCcTipsGrat) + this.parseNumber(this.form.summary.lessCcSurcharge)).toFixed(2)
                this.form.summary.totalLessGst = this.parseNumber(this.parseNumber(this.form.summary.total) / 1.1).toFixed(2);
                this.form.summary.totalSales = this.parseNumber(this.parseNumber(this.form.summary.food) + this.parseNumber(this.form.summary.bev) + this.parseNumber(this.form.summary.other)).toFixed(2);
                this.form.summary.totalLessGst2 = this.parseNumber(this.parseNumber(this.form.summary.totalSales) / 1.1).toFixed();
                this.form.summary.check = this.parseNumber(this.parseNumber(this.form.summary.totalLessGst) - this.parseNumber(this.form.summary.totalLessGst2)).toFixed(2);
                this.form.summary.sph = this.parseNumber(this.parseNumber(this.form.summary.totalLessGst) / this.parseNumber(this.form.summary.totalCovers)).toFixed(2);

                console.log(this.form.summary.totalLessGst, this.form.summary.totalSales,  this.form.summary.totalLessGst2,  this.form.summary.totalLessGst2, this.form.summary.check, this.form.summary.sph);

            },
            deep: true
        },
        'form.otherPaymentAccounts': {
            handler() {
                let totalOthers = 0;

                this.form.otherPaymentAccounts.map(item => {
                    const amount = item.amount ? this.parseNumber(item.amount) : 0;
                    totalOthers += amount;
                })

                this.form.totalOthers = totalOthers.toFixed(2);
                this.onChangeLunchTotals();

            },
            deep: true,
        },
        'form.paymentList': {
            handler() {
                const cash_takings = this.form.paymentList[0].amount ? this.parseNumber(this.form.paymentList[0].amount) : 0;
                const less_cc_tips = this.form.paymentList[1].amount ? this.parseNumber(this.form.paymentList[1].amount) : 0;
                const less_gratuity = this.form.paymentList[2].amount ? this.parseNumber(this.form.paymentList[2].amount) : 0;
                const less_petty_cash = this.form.paymentList[3].amount ? this.parseNumber(this.form.paymentList[3].amount) : 0;
                this.form.paymentList[4].amount = (cash_takings - less_cc_tips - less_gratuity - less_petty_cash).toFixed(2);

                this.form.summary.lessCcTipsGrat = ((less_cc_tips * -1) - less_gratuity).toFixed(2)

                this.onChangeUpDown();
                this.onCalculateTotalTakins();
            },
            deep: true
        },
        'form.tyros': {
            handler() {

                let totalTyro = 0;
                let totalSurcharge = 0;
                let totalRefund = 0;

                let totalLunch = {}

                this.form.tyros.map(items => {
                    items.map(item => {

                        const tyro = item.tyro ? this.parseNumber(item.tyro) : 0;
                        const surcharge = item.surcharge ? this.parseNumber(item.surcharge) : 0;
                        const refund = item.refund ? this.parseNumber(item.refund) : 0;

                        if (totalLunch[item.name]) {
                            totalLunch[item.name] += (tyro + surcharge + refund)
                        } else {
                            totalLunch[item.name] = (tyro + surcharge + refund)
                        }

                        totalTyro += tyro;
                        totalSurcharge += surcharge;
                        totalRefund += refund;


                    })
                })

                this.form.totalTyro = totalTyro;
                this.form.totalSurcharge = totalSurcharge;
                this.form.totalRefund = totalRefund

                this.form.summary.lessCcSurcharge = (totalSurcharge * -1).toFixed(2);

                this.calculateTotalTyro(totalLunch)
            },
            deep: true
        },
        'form.denominations': {
            handler() {

                let denominationTotal = 0;

                this.form.denominations.map((item, i) => {
                    let total = (item.amount  * this.parseNumber(parseInt(item.count))).toFixed(2);
                    this.form.denominations[i].total = this.parseNumber(total);
                    denominationTotal += this.parseNumber(total);
                });

                this.form.denominationTotal = denominationTotal.toFixed(2);

                this.form.paymentList[5].amount = (this.parseNumber(this.form.denominationTotal) - this.parseNumber(this.form.paymentList[0].amount) - this.parseNumber(this.form.closingFloat));
            },

            deep: true
        },
        'form.functions': {
            handler() {
                let totalCovers = 0;
                let totalFunction = 0;
                this.form.functions.map((item, i) => {
                    const cover = item.covers ? this.parseNumber(item.covers) : 0;
                    const total = item.total ? this.parseNumber(item.total) : 0;
                    totalCovers += cover;
                    totalFunction += total;
                })

                this.form.totalCovers = totalCovers;
                this.form.totalFunction = totalFunction;
            },
            deep: true
        }
    },
    methods: {
        parseNumber(number) {
            return (number && number != Infinity && number != 'NaN') ? parseFloat(number) : 0
        },
        async getCashup() {
            console.log('init data');
            const date = this.convertDate(this.reportDate);
            const res = await cashup.getCashup({
                reportDate: date,
                type: this.type,
                venueType: this.venueType
            });

            if (res.data && res.data.code == 0 && res.data.data && !this.isEmpty(res.data.data)) {
                console.log('init data2:', res.data, this.isEmpty(res.data.data));
                this.form = res.data.data;
                this.form.type = this.type;
                this.form.venueType = this.venueType;
            } else {
                this.form = form;
                this.form.date = this.convertDate(this.reportDate);
                this.form.type = this.type;
                this.form.venueType = this.venueType;
            }

        },

        isEmpty(obj) {
            for(var prop in obj) {
                if(obj.hasOwnProperty(prop))
                    return false;
            }

            return true;
        },

        async saveCashup (isSend=false, type='lunch') {
            this.form.venueType = this.venueType;
            this.form.type = type;

            const res = await cashup.saveCashup(this.form, isSend);

            if (res.data && res.data.code == 0) {
                if (isSend) {
                    utils.alert2('', 'Successfully saved cashup', 'success');
                }
            }
            console.log('saveCashup:', this.form, this.type, isSend);


        },


        onChangeTotalDenomination() {

        },
        onChangeUpDown() {
            this.form.paymentList[5].amount = (this.parseNumber(this.form.denominationTotal) - this.parseNumber(this.form.paymentList[0].amount) - this.parseNumber(this.form.closingFloat)) ;
        },
        calculateTotalTyro (totalLunch) {
            for (const key in totalLunch) {
                if (Object.hasOwnProperty.call(totalLunch, key)) {
                    const total = totalLunch[key];
                    const index = this.form.lunchTotals.findIndex(obj => obj.name == key)
                    let variance = total * -1;
                    this.form.lunchTotals[index].total = total;
                    this.form.lunchTotals[index].variance = (variance + this.parseNumber(this.form.lunchTotals[index].bepoz))
                }
            }

            this.onChangeLunchTotals();

        },
        onChangeLunchTotals() {
            let totalLunchTyro = 0;
            let totalLunchBepoz = 0;
            let totalLunchVariance = 0;

            this.form.lunchTotals.map((item, i) => {
                const variance = (item.total * -1);
                this.form.lunchTotals[i].variance = (variance + this.parseNumber(item.bepoz))

                totalLunchTyro += this.parseNumber(item.total);
                totalLunchBepoz += this.parseNumber(item.bepoz);
                totalLunchVariance += item.variance;
            });

            this.form.totalLunchTyro = totalLunchTyro;
            this.form.totalLunchBepoz =  totalLunchBepoz;
            this.form.totalLunchVariance = totalLunchVariance;

            this.onCalculateTotalTakins();
        },
        onChangeOpeningFloat() {

        },
        onChangeClosingFloat() {
            this.onChangeUpDown();

        },
        onCalculateTotalTakins() {
            this.form.summary.totalTakings = (this.parseNumber(this.form.totalLunchTyro) + this.parseNumber(this.form.totalOthers) + this.parseNumber(this.form.paymentList[0].amount))
        },
        onChangePettyCash() {
            let total = 0;
            this.form.pettyCashList.map(item => {
                const amount  = item.amount ? this.parseNumber(item.amount) : 0;
                total += amount;
            })

            this.form.pettyCashTotal = total;
            this.form.paymentList[3].amount = total;

        },
        addItem (list, newData) {
            console.log('ist, newData: ', list, newData);
            list.push(newData);
        },

        removeItem(index, key) {

            this.form[key] = this.form[key].filter((item, i) => index != i);
        },

        convertDate(dateString) {
            let parts = dateString.split('-');
            let formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
            return formattedDate;
        },


        handleClose() {
            this.isOpen = false
        },
        handleActiveTab () {

        }
    },
    mounted() {

        this.form.date = this.convertDate(this.reportDate);
        this.form.type = this.type;
        this.form.venueType = this.venueType;

        this.getCashup();


        this.isOpen = true;

        document.addEventListener('DOMContentLoaded', (event) => {
            const inputs = document.querySelectorAll('input');
            inputs.forEach((input, index) => {
                input.addEventListener('input', () => {
                    console.log('enter');
                    if (input.value.length >= input.maxLength) {
                        const nextInput = inputs[index + 1];
                        if (nextInput) {
                            nextInput.focus();
                        }
                    }
                });
            });
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/form/cashupForm.vue